import React, {Fragment, Component} from "react";
import {Link} from 'react-router-dom';
import {Col, Row, Form, FormGroup, Label, Input, Container} from 'reactstrap';
import LaddaButton, {ZOOM_IN} from 'react-ladda';
import axios from 'axios';
import {server_host_api,IsEmail,ValidarCNPJ,getLanguageApi} from '../../../Utils';
import {toast} from 'react-toastify';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';
import {translate} from 'react-switch-lang';

class Register extends Component {
    constructor(props) {
        super(props);

        this.state = {
            registerLoading: false,
            email: "",
            firstname: "",
            lastname: "",
            phone: "",
            cnpj: "",
            password: "",
            passwordrep: "",
            termsandcondictions: false,
            phoneMask: null,
            createSuccess: false
        }; 
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleChangePhone = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });

        var mask = {
            mask: '(99) 9999-9999'
        };

        if (e.target.value.replace(/\D+/g, '')[2] === "9") {
            mask.mask = '(99) 99999-9999';
        }

        this.setState({
            phoneMask:mask
        });
    }

    Register = () => {
        const { t } = this.props;

        if (!this.state.email) {
            toast.warn(<div><b>{t('required_data')}</b><br /> {t('register.mail_required')}</div>);
            return false;
        }

        if (!IsEmail(this.state.email)) {
            toast.warn(<div><b>{t('register.warning_toast_header')}</b><br /> {t('register.mail_valid_required')}</div>);
            return false;
        }

        if (!this.state.firstname) {
            toast.warn(<div><b>{t('required_data')}</b><br /> {t('register.fistname_required')}</div>);
            return false;
        }

        if (!this.state.lastname) {
            toast.warn(<div><b>{t('required_data')}</b><br /> {t('register.lastname_required')}</div>);            
            return false;
        }

        if (!this.state.phone) {
            toast.warn(<div><b>{t('required_data')}</b><br /> {t('register.phone_required')}</div>);
            return false;
        }

        if (!this.state.cnpj) {
            toast.warn(<div><b>{t('required_data')}</b><br /> {t('register.cnpj_required')}</div>);
            return false;
        }

        if (!ValidarCNPJ(this.state.cnpj)) {
            toast.warn(<div><b>{t('register.warning_toast_header')}</b><br /> {t('register.cnpj_valid_required')}</div>);
            return false;
        }

        if (!this.state.password) {
            toast.warn(<div><b>{t('required_data')}</b><br /> {t('register.password_required')}</div>);
            return false;
        }

        if (!this.state.passwordrep) {
            toast.warn(<div><b>{t('required_data')}</b><br /> {t('register.confirm_password_required')}</div>);
            return false;
        }

        if (this.state.password !== this.state.passwordrep) {
            toast.warn(<div><b>{t('register.warning_toast_header')}</b><br /> {t('register.password_equal')}</div>);
            return false;
        }

        if (this.state.termsandcondictions === false) {
            toast.warn(<div><b>{t('register.warning_toast_header')}</b><br /> {t('register.accept_terms')}</div>);
            return false;
        }

        this.setState({
            registerLoading: true,
            progress: 0.5,
        });

        axios.post(`${server_host_api}/user/register/`,{
            "email": this.state.email,
            "first_name": this.state.firstname,
            "last_name": this.state.lastname,
            "phone_number": this.state.phone.replace(/[^0-9]/g, ''),
            "password": this.state.password,
            "password2": this.state.passwordrep,
            "cnpj": this.state.cnpj.replace(/[^0-9]/g, ''),
        },{
            headers: { "Accept-Language": getLanguageApi() }
        })
        .then(res => {
            this.setState({
                auth: res.data 
            });

            if ((res.status === 200) ||
                (res.status === 201)) {
                this.setState({
                    registerLoading: false,
                    progress: 0,
                    createSuccess: true
                });
            } else {
                this.setState({
                    registerLoading: false,
                    progress: 0,
                });
                
                toast.error(<div><b>{t('register.create_account_error')}</b><br /> {t('register.try_again_later')}</div>);
            }
        })
        .catch(error => {
            this.setState({
                registerLoading: false,
                progress: 0,
            });
            
            toast.error(<div><b>{t('register.create_account_error')}</b><br /> {error.response.data.messages.map((item, i) => {
                return <p key={i} style={{margin: 0, padding: 0}}>{item}</p>;
            })}</div>);
        });
    }

    render() {
        const { t } = this.props;

        if (this.state.createSuccess === true) {
            return (
                <Fragment>
                    <Container fluid>
                        <div className="h-100">
                            <Row className="h-100 no-gutters">
                                <Col lg="12" md="12" className="h-100 d-md-flex d-sm-block bg-white justify-content-center align-items-center">
                                    <Col lg="9" md="10" sm="12" className="mx-auto app-login-box">
                                        <div className="form-wizard-content">
                                            <div className="no-results">
                                                <div className="sa-icon sa-success animate">
                                                    <span className="sa-line sa-tip animateSuccessTip"/>
                                                    <span className="sa-line sa-long animateSuccessLong"/>

                                                    <div className="sa-placeholder"/>
                                                    <div className="sa-fix"/>
                                                </div>
                                                <div className="results-subtitle mt-4">{t('register.ready')}</div>
                                                <div className="results-title">{t('register.create_account_success')}</div>
                                                <div className="mt-3 mb-3"/>
                                                <div className="text-center">
                                                    {t('register.validate_mail')}
                                                </div>
                                                <div className="text-center">
                                                    <h5 className="mb-0 mt-5">
                                                        <Link to="/auth/login" className="text-primary">{t('register.access_now')}</Link>
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Col>
                            </Row>
                        </div>
                    </Container>
                </Fragment>
            )
        }
        else {
            return (
                <Fragment>
                    <div className="h-100">
                        <Row className="h-100 no-gutters">
                            <Col lg="12" md="12" className="h-100 d-md-flex d-sm-block bg-white justify-content-center align-items-center">
                                <Col lg="9" md="10" sm="12" className="mx-auto app-login-box">
                                    <div className="app-logo"/>
                                    <h4>
                                        <div>{t('register.welcome')}</div>
                                        <span>{t('register.create_account_now_1')} <span className='text-success'>{t('register.create_account_now_2')}</span></span>
                                    </h4>
                                    <div>
                                        <Form>
                                            <Row form>
                                                <Col md={12}>
                                                    <FormGroup>
                                                        <Label for="email">
                                                            {t('register.mail')}<div className="mb-2 ml-2 badge badge-dot badge-dot-sm badge-danger">.</div>
                                                        </Label>
                                                        <Input type="email" name="email" id="email" onChange={e => this.handleChange(e)}/>
                                                    </FormGroup>
                                                </Col>
                                                <Col md={6}>
                                                    <FormGroup>
                                                        <Label for="firstname">{t('register.firstname')}<div className="mb-2 ml-2 badge badge-dot badge-dot-sm badge-danger">.</div></Label>
                                                        <Input type="text" name="firstname" id="firstname" onChange={e => this.handleChange(e)}/>
                                                    </FormGroup>
                                                </Col>
                                                <Col md={6}>
                                                    <FormGroup>
                                                        <Label for="lastname">{t('register.lastname')}<div className="mb-2 ml-2 badge badge-dot badge-dot-sm badge-danger">.</div></Label>
                                                        <Input type="text" name="lastname" id="lastname" onChange={e => this.handleChange(e)}/>
                                                    </FormGroup>
                                                </Col>
                                                <Col md={6}>
                                                    <FormGroup>
                                                        <Label for="phone">{t('register.phone')}<div className="mb-2 ml-2 badge badge-dot badge-dot-sm badge-danger">.</div></Label>
                                                        <InputMask className="form-control" type="text" name="phone" id="phone" {...this.state.phoneMask} onChange={e => this.handleChangePhone(e)}/>
                                                    </FormGroup>
                                                </Col>
                                                <Col md={6}>
                                                    <FormGroup>
                                                        <Label for="cnpj">{t('register.cnpj')}<div className="mb-2 ml-2 badge badge-dot badge-dot-sm badge-danger">.</div></Label>
                                                        <InputMask className="form-control" type="text" name="cnpj" id="cnpj" mask="99.999.999/9999-99" onChange={e => this.handleChange(e)}/>
                                                    </FormGroup>
                                                </Col>
                                                <Col md={6}>
                                                    <FormGroup>
                                                        <Label for="password">{t('register.password')}<div className="mb-2 ml-2 badge badge-dot badge-dot-sm badge-danger">.</div></Label>
                                                        <Input type="password" name="password" id="password" onChange={e => this.handleChange(e)}/>
                                                    </FormGroup>
                                                </Col>
                                                <Col md={6}>
                                                    <FormGroup>
                                                        <Label for="passwordrep">{t('register.confirm_password')}<div className="mb-2 ml-2 badge badge-dot badge-dot-sm badge-danger">.</div></Label>
                                                        <Input type="password" name="passwordrep" id="passwordrep" onChange={e => this.handleChange(e)}/>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <FormGroup className="mt-3" check>
                                                <Input type="checkbox" name="termsandcondictions" onChange={e => this.handleChange(e)} id="termsandcondictions"/>
                                                <Label for="termsandcondictions" check>{t('register.accept_terms_1')} <a href="https://colorlib.com/" onClick={(e)=>e.preventDefault()}>{t('register.accept_terms_2')}</a>.</Label>
                                            </FormGroup>
                                        </Form>
                                        <div className="mt-4 d-flex align-items-center">
                                            <h5 className="mb-0">
                                                {t('register.do_you_have_account')}{' '}
                                                <Link to="/auth/login" className="text-primary">{t('register.access_your_account')}</Link>
                                            </h5>
                                            <div className="ml-auto">
                                                <LaddaButton className="btn btn-primary btn-wide btn-pill btn-shadow btn-hover-shine" style={{fontSize: "14pt"}} onClick={e => this.Register()} loading={this.state.registerLoading} data-style={ZOOM_IN}>{t('register.create_your_account')}</LaddaButton>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Col>
                        </Row>
                    </div>
                </Fragment>
            );
        }
    }
}

Register.propTypes = {
    t: PropTypes.func.isRequired,
};

export default translate(Register);